import React from 'react';

import { PreferencesCommunication } from '../components/Preferences/PreferencesCommunication';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type CommunicationsPreferencesPageProps = {
  name?: string;
};

export const CommunicationsPreferencesPage = ({
  name = 'COMMUNICATIONS_PREFERENCES_PAGE',
}: CommunicationsPreferencesPageProps) => {
  useDocumentTitle('Preferences');
  return (
    <div data-test={name}>
      <PreferencesCommunication />
    </div>
  );
};
